const menuItems = {
  items: [
    {
      id: 'admin-panel',
      title: 'teacher-Panel',
      type: 'group',
      icon: 'icon-monitor',
      children: [
        {
          id: 'main-dashboard',
          title: 'Dashboard',
          icon: 'fas fa-home',
          type: 'item',
          url: `/teacher-portal/dashboard`
        },
        {
          id: 'syllabus',
          title: 'Syllabus',
          icon: 'fas fa-book-open',
          type: 'item',
          url: `/teacher-portal/syllabus`
        },
        {
          id: 'student',
          title: 'Student',
          icon: 'fas fa-user-graduate',
          type: 'item',
          url: '/teacher-portal/student'
        },
        {
          id: 'questionPapers',
          title: 'Question Papers',
          type: 'collapse',
          icon: 'fas fa-book',
          children: [
            {
              id: 'activeQuestionPapers',
              title: 'Active',
              type: 'item',
              url: '/teacher-portal/active-question-papers'
            },
            {
              id: 'archivedQuestionPapers',
              title: 'Archived',
              type: 'item',
              url: '/teacher-portal/archived-question-papers'
            }
          ]
        },
        {
          id: 'testSchedule',
          title: 'Test Schedule',
          type: 'collapse',
          icon: 'fas fa-newspaper',
          children: [
            {
              id: 'activeTestSchedule',
              title: 'Active',
              type: 'item',
              url: '/teacher-portal/active-test-schedule'
            },
            {
              id: 'archivedTestSchedule',
              title: 'Archived',
              type: 'item',
              url: '/teacher-portal/archived-test-schedule'
            }
          ]
        },
        {
          id: 'workSheet',
          title: 'WorkSheet',
          type: 'collapse',
          icon: 'fas fa-newspaper',
          children: [
            {
              id: 'activeWorkSheet',
              title: 'Active',
              type: 'item',
              url: '/teacher-portal/active-worksheet'
            },
            {
              id: 'archivedWorkSheet',
              title: 'Archived',
              type: 'item',
              url: '/teacher-portal/archived-worksheet'
            }
          ]
        },
        {
          id: 'teacherSessions',
          title: 'Teacher Sessions',
          icon: 'fas fa-user-graduate',
          type: 'item',
          url: '/teacher-portal/teacherSessions'
        },
        {
          id: 'curriculumPlanner',
          title: 'Curriculum Planner',
          icon: 'fas fa-calendar-alt',
          type: 'item',
          url: '/teacher-portal/curriculum-planner'
        }
      ]
    }
  ]
};

export default menuItems;
